const DEFAULT_COLLAPSED_HEIGHT = 200;

const parseHeight = (value) => {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? DEFAULT_COLLAPSED_HEIGHT : parsed;
};

const initSeoCollapsible = (section) => {
    const content = section.querySelector('[data-collapsible-content]');
    const toggle = section.querySelector('[data-collapsible-toggle]');
    const fade = section.querySelector('[data-collapsible-fade]');

    if (!content || !toggle) {
        return;
    }

    const collapsedHeight = parseHeight(section.dataset.collapsedHeight);
    const collapsedLabel = toggle.dataset.labelCollapsed?.trim() || toggle.textContent.trim();
    const expandedLabel = toggle.dataset.labelExpanded?.trim() || collapsedLabel;
    let enabled = false;

    const updateFade = (expanded) => {
        if (!fade) return;
        fade.classList.toggle('SeoContent__fade--hidden', expanded);
    };

    const setMaxHeight = (height) => {
        content.style.maxHeight = height ? `${height}px` : '';
    };

    const applyState = (expanded) => {
        section.classList.toggle('SeoContent--expanded', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? expandedLabel : collapsedLabel;
        setMaxHeight(expanded ? content.scrollHeight : collapsedHeight);
        updateFade(expanded);
    };

    const disableCollapse = () => {
        enabled = false;
        section.classList.remove('SeoContent--expanded');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.hidden = true;
        setMaxHeight(null);
        updateFade(true);
    };

    const enableCollapse = () => {
        enabled = true;
        toggle.hidden = false;
        if (!section.classList.contains('SeoContent--expanded')) {
            setMaxHeight(collapsedHeight);
        } else {
            setMaxHeight(content.scrollHeight);
        }
        updateFade(section.classList.contains('SeoContent--expanded'));
    };

    const evaluate = () => {
        const fullHeight = content.scrollHeight;
        const shouldCollapse = fullHeight > collapsedHeight + 16;
        if (!shouldCollapse) {
            disableCollapse();
            return;
        }
        enableCollapse();
        applyState(section.classList.contains('SeoContent--expanded'));
    };

    evaluate();
    window.addEventListener('load', evaluate);

    toggle.addEventListener('click', () => {
        if (!enabled) return;
        const expanded = !section.classList.contains('SeoContent--expanded');
        applyState(expanded);
    });

    const refreshMaxHeight = () => {
        if (!enabled) return;
        const expanded = section.classList.contains('SeoContent--expanded');
        setMaxHeight(expanded ? content.scrollHeight : collapsedHeight);
    };

    if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => {
            evaluate();
            refreshMaxHeight();
        });
        observer.observe(content);
    } else {
        window.addEventListener('resize', () => {
            evaluate();
            refreshMaxHeight();
        });
    }
};

const initializeSeoCollapsibles = () => {
    document.querySelectorAll('[data-component="seo-collapsible"]').forEach((section) => {
        initSeoCollapsible(section);
    });
};

document.addEventListener('DOMContentLoaded', initializeSeoCollapsibles);
